
// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "./CoursesList.css";

// const courses = [
//     {
//         id: 1,
//         title: "Website Frontend",
//         icon: "💻",
//         description: "Design responsive and interactive websites.",
//         levels: [
//             {
//                 name: "Level 1 - Frontend Fundamentals",
//                 duration: "1.5 Months",
//                 fee: 6000,
//                 topics: [
//                     "HTML5 and Website Structure",
//                     "CSS3, Selectors and Styling",
//                     "Forms and Semantic HTML",
//                     "Flexbox and CSS Grid",
//                     "Responsive Web Design",
//                     "Bootstrap Fundamentals",
//                     "JavaScript Variables and Data Types",
//                     "Conditions, Loops and Functions",
//                     "DOM Manipulation and Events",
//                     "Mini Project: Responsive Website",
//                 ],
//             },
//             {
//                 name: "Level 2 - React.js Development",
//                 duration: "1.5 Months",
//                 fee: 8000,
//                 topics: [
//                     "Modern JavaScript ES6+",
//                     "Array Methods, Destructuring and Modules",
//                     "React.js Fundamentals",
//                     "Components, Props and State",
//                     "Hooks: useState and useEffect",
//                     "Forms and Event Handling",
//                     "React Router and Navigation",
//                     "API Integration using Fetch or Axios",
//                     "Git and GitHub",
//                     "Project Deployment",
//                     "Project: Dynamic React Website",
//                 ],
//             },
//         ],
//     },
//     {
//         id: 2,
//         title: "Website Backend",
//         icon: "⚙️",
//         description: "Build server-side applications, APIs and databases.",
//         levels: [
//             {
//                 name: "Level 1 - Backend Fundamentals",
//                 duration: "1.5 Months",
//                 fee: 7000,
//                 topics: [
//                     "Backend Development Fundamentals",
//                     "JavaScript for Backend",
//                     "Node.js Introduction",
//                     "Node.js Modules and npm",
//                     "HTTP and Client-Server Architecture",
//                     "JSON Data Handling",
//                     "Basic Server Creation",
//                     "Introduction to REST APIs",
//                     "Database Fundamentals",
//                     "Mini Project: Basic Node.js Server",
//                 ],
//             },
//             {
//                 name: "Level 2 - Advanced Backend Development",
//                 duration: "1.5 Months",
//                 fee: 10000,
//                 topics: [
//                     "Express.js Framework",
//                     "REST API Development",
//                     "Routing and Middleware",
//                     "MySQL or MongoDB Fundamentals",
//                     "CRUD Operations",
//                     "Frontend and Database Integration",
//                     "Authentication and Authorization",
//                     "Password Hashing and Security Basics",
//                     "Input Validation and Error Handling",
//                     "Environment Variables",
//                     "Backend Deployment",
//                     "Project: Complete Backend API",
//                 ],
//             },
//         ],
//     },
//     {
//         id: 3,
//         title: "Full Stack Web Development",
//         subtitle: "Frontend + Backend",
//         icon: "🚀",
//         description:
//             "Learn to develop complete websites from frontend to backend.",
//         levels: [
//             {
//                 name: "Level 1 - Full Stack Fundamentals",
//                 duration: "3 Months",
//                 fee: 12000,
//                 topics: [
//                     "HTML5, CSS3 and JavaScript",
//                     "Responsive Website Design",
//                     "Bootstrap Fundamentals",
//                     "JavaScript DOM and ES6+",
//                     "React.js Introduction",
//                     "Components, Props and State",
//                     "React Hooks Fundamentals",
//                     "Node.js Introduction",
//                     "Basic Server Development",
//                     "Database Fundamentals",
//                     "Git and GitHub Basics",
//                     "Project: Frontend Website with Basic Backend",
//                 ],
//             },
//             {
//                 name: "Level 2 - Advanced Full Stack Development",
//                 duration: "3 Months",
//                 fee: 15000,
//                 topics: [
//                     "Advanced React.js",
//                     "React Router and Form Handling",
//                     "API Integration",
//                     "Node.js and Express.js",
//                     "REST API Development",
//                     "MySQL or MongoDB Integration",
//                     "CRUD Operations",
//                     "Authentication and Authorization",
//                     "Frontend-Backend Integration",
//                     "Application Security Basics",
//                     "Deployment and Environment Configuration",
//                     "Live Full Stack Project",
//                 ],
//             },
//         ],
//     },
//     {
//         id: 4,
//         title: "Artificial Intelligence (AI)",
//         icon: "🤖",
//         description: "Learn AI fundamentals, modern AI tools and AI applications.",
//         levels: [
//             {
//                 name: "Level 1 - AI Fundamentals",
//                 duration: "1.5 Months",
//                 fee: 7000,
//                 topics: [
//                     "Introduction to Artificial Intelligence",
//                     "AI, Machine Learning and Deep Learning Overview",
//                     "Python Installation and Setup",
//                     "Python Variables and Data Types",
//                     "Conditions, Loops and Functions",
//                     "Lists, Dictionaries and Sets",
//                     "Python Modules and Libraries",
//                     "Introduction to Data Handling",
//                     "AI Tools and Responsible AI Usage",
//                     "Mini Project: Python-Based AI Utility",
//                 ],
//             },
//             {
//                 name: "Level 2 - Generative AI and Applications",
//                 duration: "1.5 Months",
//                 fee: 8000,
//                 topics: [
//                     "Machine Learning Fundamentals",
//                     "Generative AI Concepts",
//                     "Large Language Models (LLMs)",
//                     "Prompt Engineering",
//                     "Working with AI APIs",
//                     "Python Integration with AI Services",
//                     "Chatbot Development",
//                     "Text Processing and AI Automation",
//                     "AI Application Testing and Evaluation",
//                     "AI Safety and Data Privacy",
//                     "Project: AI Chatbot or Assistant",
//                 ],
//             },
//         ],
//     },
//     {
//         id: 5,
//         title: "Salesforce Admin",
//         icon: "☁️",
//         description: "Learn Salesforce CRM configuration and administration.",
//         levels: [
//             {
//                 name: "Level 1 - Salesforce Admin Fundamentals",
//                 duration: "1 Month",
//                 fee: 5000,
//                 topics: [
//                     "Salesforce Introduction and CRM Concepts",
//                     "Salesforce Setup and Navigation",
//                     "Standard and Custom Objects",
//                     "Fields, Tabs and Relationships",
//                     "Page Layouts and Record Types",
//                     "List Views and Search",
//                     "Accounts, Contacts and Opportunities",
//                     "Reports and Dashboards",
//                     "Data Import and Export Basics",
//                     "Mini Project: CRM Configuration",
//                 ],
//             },
//             {
//                 name: "Level 2 - Advanced Salesforce Administration",
//                 duration: "1 Month",
//                 fee: 7000,
//                 topics: [
//                     "Validation Rules",
//                     "Formula Fields",
//                     "Flow Builder and Automation",
//                     "Approval Process Concepts",
//                     "Profiles and Permission Sets",
//                     "Roles and Role Hierarchy",
//                     "Organization-Wide Defaults",
//                     "Sharing Rules and Record Access",
//                     "Data Loader",
//                     "Debugging Flows and Troubleshooting",
//                     "Real-World Admin Project",
//                 ],
//             },
//         ],
//     },
//     {
//         id: 6,
//         title: "Salesforce Developer",
//         icon: "👨‍💻",
//         description: "Learn Apex programming and custom Salesforce development.",
//         levels: [
//             {
//                 name: "Level 1 - Salesforce Development Fundamentals",
//                 duration: "1.5 Months",
//                 fee: 8000,
//                 topics: [
//                     "Salesforce Developer Environment",
//                     "Developer Console and VS Code Overview",
//                     "Apex Introduction",
//                     "Variables, Data Types and Operators",
//                     "Conditions and Loops",
//                     "Collections: List, Set and Map",
//                     "Methods and Classes",
//                     "SOQL Queries",
//                     "SOSL Search",
//                     "DML Operations",
//                     "Exception Handling",
//                     "Mini Project: Apex Data Operations",
//                 ],
//             },
//             {
//                 name: "Level 2 - Advanced Salesforce Development",
//                 duration: "1.5 Months",
//                 fee: 10000,
//                 topics: [
//                     "Apex Triggers",
//                     "Trigger Context Variables",
//                     "Bulkification and Governor Limits",
//                     "Trigger Handler Patterns",
//                     "Asynchronous Apex",
//                     "Batch Apex and Scheduled Apex",
//                     "Queueable and Future Methods",
//                     "Apex Test Classes and Code Coverage",
//                     "REST API Integration Fundamentals",
//                     "Debugging and Best Practices",
//                     "Project: Automated Salesforce Application",
//                 ],
//             },
//         ],
//     },
//     {
//         id: 7,
//         title: "Salesforce LWC",
//         icon: "⚡",
//         description: "Build reusable user interfaces with Lightning Web Components.",
//         levels: [
//             {
//                 name: "Level 1 - LWC Fundamentals",
//                 duration: "1 Month",
//                 fee: 6000,
//                 topics: [
//                     "Lightning Web Components Introduction",
//                     "HTML and CSS Fundamentals",
//                     "JavaScript Fundamentals",
//                     "LWC Project Structure",
//                     "Creating and Deploying Components",
//                     "Properties and Data Binding",
//                     "Conditional Rendering",
//                     "List Rendering",
//                     "Event Handling",
//                     "Parent-Child Component Basics",
//                     "Mini Project: Custom Salesforce UI",
//                 ],
//             },
//             {
//                 name: "Level 2 - Advanced LWC Development",
//                 duration: "1 Month",
//                 fee: 9000,
//                 topics: [
//                     "Lifecycle Hooks",
//                     "Component Communication",
//                     "Custom Events",
//                     "Lightning Data Service",
//                     "Wire Service and Reactive Properties",
//                     "Calling Apex from LWC",
//                     "Navigation and Toast Messages",
//                     "Forms and Record Operations",
//                     "Error Handling and Loading States",
//                     "Reusable Component Design",
//                     "Project: Complete LWC Application",
//                 ],
//             },
//         ],
//     },
//     {
//         id: 8,
//         title: "Digital Marketing",
//         icon: "📈",
//         description: "Learn digital marketing, advertising and lead generation.",
//         levels: [
//             {
//                 name: "Level 1 - Digital Marketing Fundamentals",
//                 duration: "1 Month",
//                 fee: 4000,
//                 topics: [
//                     "Digital Marketing Introduction",
//                     "Digital Marketing Channels",
//                     "Website and Landing Page Fundamentals",
//                     "SEO Fundamentals",
//                     "Keyword Research",
//                     "On-Page SEO",
//                     "Content Marketing",
//                     "Social Media Marketing",
//                     "Content Creation Basics",
//                     "Google Business Profile Fundamentals",
//                     "Mini Project: Digital Marketing Plan",
//                 ],
//             },
//             {
//                 name: "Level 2 - Advanced Digital Marketing",
//                 duration: "1 Month",
//                 fee: 5000,
//                 topics: [
//                     "Technical SEO Fundamentals",
//                     "Off-Page SEO and Link Building",
//                     "Google Ads Campaign Setup",
//                     "Meta Ads Campaign Setup",
//                     "Audience Targeting",
//                     "Campaign Budgeting",
//                     "Google Analytics Fundamentals",
//                     "Conversion Tracking",
//                     "Lead Generation Strategies",
//                     "Campaign Optimization",
//                     "Performance Reporting",
//                     "Project: Marketing Campaign",
//                 ],
//             },
//         ],
//     },
// ];

// const formatPrice = (price) =>
//     new Intl.NumberFormat("en-IN", {
//         style: "currency",
//         currency: "INR",
//         maximumFractionDigits: 0,
//     }).format(price);

// function CoursesList() {
//     const [selectedCourse, setSelectedCourse] = useState(null);
//     const navigate = useNavigate();

//     const handleEnroll = (course) => {
//         navigate(
//             `/contact?course=${encodeURIComponent(course.title)}`
//         );
//     };

//     return (
//         <main className="ap-courses">
//             <section className="ap-courses-hero">
//                 <span className="ap-courses-eyebrow">
//                     A.P TECH SOLUTIONS
//                 </span>
//                 <h1>Our Professional Courses</h1>
//                 <p>
//                     Learn practical skills, build real-world projects, and
//                     prepare for your technology career.
//                 </p>
//             </section>

//             <section className="ap-courses-content">
//                 <div className="ap-courses-heading">
//                     <div>
//                         <h2>Explore Our Courses</h2>
//                         <p>
//                             Start from Level 1 or choose Level 2 if you already
//                             know the fundamentals.
//                         </p>
//                     </div>
//                     <span className="ap-course-count">
//                         {courses.length} Courses
//                     </span>
//                 </div>

//                 <div className="ap-course-table-wrap">
//                     <table className="ap-course-table">
//                         <thead>
//                             <tr>
//                                 <th>Course Name</th>
//                                 <th>Topics Covered</th>
//                                 <th>Duration</th>
//                                 <th>Level 1 Fee</th>
//                                 <th>Level 2 Fee</th>
//                                 <th>Action</th>
//                             </tr>
//                         </thead>

//                         <tbody>
//                             {courses.map((course) => (
//                                 <tr key={course.id}>
//                                     <td>
//                                         <div className="ap-course-name">
//                                             <span className="ap-course-icon">
//                                                 {course.icon}
//                                             </span>
//                                             <div>
//                                                 <strong>{course.title}</strong>
//                                                 {course.subtitle && (
//                                                     <small>{course.subtitle}</small>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     </td>

//                                     <td>
//                                         <div className="ap-course-short-topics">
//                                             <span>
//                                                 <b>Level 1:</b>{" "}
//                                                 {course.levels[0].topics.slice(0, 3).join(", ")}
//                                             </span>
//                                             <span>
//                                                 <b>Level 2:</b>{" "}
//                                                 {course.levels[1].topics.slice(0, 3).join(", ")}
//                                             </span>
//                                         </div>
//                                     </td>

//                                     <td>
//                                         <div className="ap-course-duration">
//                                             <span>{course.levels[0].duration}</span>
//                                             <span>{course.levels[1].duration}</span>
//                                         </div>
//                                     </td>

//                                     <td>
//                                         <strong className="ap-course-price">
//                                             {formatPrice(course.levels[0].fee)}
//                                         </strong>
//                                     </td>

//                                     <td>
//                                         <strong className="ap-course-price">
//                                             {formatPrice(course.levels[1].fee)}
//                                         </strong>
//                                     </td>

//                                     <td>
//                                         <button
//                                             type="button"
//                                             className="ap-course-details-btn"
//                                             onClick={() => setSelectedCourse(course)}
//                                         >
//                                             Details
//                                             <span aria-hidden="true"> →</span>
//                                         </button>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>

//                 <div className="ap-course-mobile-list">
//                     {courses.map((course) => (
//                         <article className="ap-course-card" key={course.id}>
//                             <div className="ap-course-card-heading">
//                                 <span className="ap-course-icon">{course.icon}</span>
//                                 <div>
//                                     <h3>{course.title}</h3>
//                                     <p>{course.description}</p>
//                                 </div>
//                             </div>

//                             <div className="ap-course-card-levels">
//                                 {course.levels.map((level) => (
//                                     <div className="ap-course-level" key={level.name}>
//                                         <div className="ap-course-level-title">
//                                             <strong>{level.name}</strong>
//                                             <strong>{formatPrice(level.fee)}</strong>
//                                         </div>
//                                         <p>{level.duration}</p>
//                                         <p>
//                                             {level.topics.slice(0, 4).join(", ")}
//                                         </p>
//                                     </div>
//                                 ))}
//                             </div>

//                             <button
//                                 type="button"
//                                 className="ap-course-details-btn ap-course-details-full"
//                                 onClick={() => setSelectedCourse(course)}
//                             >
//                                 View Course Details →
//                             </button>
//                         </article>
//                     ))}
//                 </div>

//                 <div className="ap-course-note">
//                     <strong>Which level should you choose?</strong>
//                     <p>
//                         Level 1 is for beginners. Level 2 is for students who
//                         already understand the basics and want to develop advanced
//                         skills. Check the prerequisites in the course details.
//                     </p>
//                 </div>
//             </section>

//             {selectedCourse && (
//                 <div
//                     className="ap-course-modal-overlay"
//                     onMouseDown={(event) => {
//                         if (event.target === event.currentTarget) {
//                             setSelectedCourse(null);
//                         }
//                     }}
//                 >
//                     <section
//                         className="ap-course-modal"
//                         role="dialog"
//                         aria-modal="true"
//                         aria-labelledby="ap-course-modal-title"
//                     >
//                         <div className="ap-course-modal-header">
//                             <div className="ap-course-modal-title-wrap">
//                                 <span className="ap-course-icon">
//                                     {selectedCourse.icon}
//                                 </span>
//                                 <div>
//                                     <span className="ap-courses-eyebrow">
//                                         COURSE DETAILS
//                                     </span>
//                                     <h2 id="ap-course-modal-title">
//                                         {selectedCourse.title}
//                                     </h2>
//                                     {selectedCourse.subtitle && (
//                                         <p>{selectedCourse.subtitle}</p>
//                                     )}
//                                 </div>
//                             </div>

//                             <button
//                                 type="button"
//                                 className="ap-course-close"
//                                 aria-label="Close course details"
//                                 onClick={() => setSelectedCourse(null)}
//                             >
//                                 ×
//                             </button>
//                         </div>

//                         <p className="ap-course-modal-description">
//                             {selectedCourse.description}
//                         </p>

//                         <div className="ap-course-modal-levels">
//                             {selectedCourse.levels.map((level, index) => (
//                                 <article className="ap-course-detail-level" key={level.name}>
//                                     <div className="ap-course-detail-top">
//                                         <div>
//                                             <span className="ap-course-level-badge">
//                                                 LEVEL {index + 1}
//                                             </span>
//                                             <h3>{level.name}</h3>
//                                         </div>
//                                         <div className="ap-course-detail-price">
//                                             <strong>{formatPrice(level.fee)}</strong>
//                                             <span>{level.duration}</span>
//                                         </div>
//                                     </div>

//                                     <h4>What You Will Learn</h4>
//                                     <ul className="ap-course-topic-list">
//                                         {level.topics.map((topic) => (
//                                             <li key={topic}>
//                                                 <span aria-hidden="true">✓</span>
//                                                 {topic}
//                                             </li>
//                                         ))}
//                                     </ul>

//                                     <button
//                                         type="button"
//                                         className="ap-course-enroll-btn"
//                                         onClick={() =>
//                                             handleEnroll({
//                                                 title: selectedCourse.title,
//                                                 level: level.name,
//                                             })
//                                         }
//                                     >
//                                         Enquire for {index === 0 ? "Level 1" : "Level 2"}
//                                         <span aria-hidden="true"> →</span>
//                                     </button>
//                                 </article>
//                             ))}
//                         </div>

//                         <p className="ap-course-modal-footnote">
//                             Course duration and fees are indicative and may be
//                             confirmed with the admissions team before enrollment.
//                         </p>
//                     </section>
//                 </div>
//             )}
//         </main>
//     );
// }



// export default CoursesList; 







import React, { useState } from "react";
import "./CoursesList.css";

const courses = [
    {
        id: 1,
        title: "Website Frontend",
        icon: "💻",
        description: "Design responsive and interactive websites.",
        levels: [
            {
                name: "Level 1 - Frontend Fundamentals",
                duration: "3 Months",
                fee: 10000,
                topics: [ 
                    "HTML5, CSS",
                    "JavaScript and WebsiteStructure",
                    "Bootstrap Fundamentals",
                    "Flexbox and CSS Grid",
                    "Responsive Web Design",
                    
                    


                    
                    "CSS3, Selectors and Styling",
                    "Forms and Semantic HTML",
                   
                    "JavaScript Variables and Data Types",
                    "Conditions, Loops and Functions",
                    "DOM Manipulation and Events",
                    "Mini Project: Responsive Website",
                ],
            },
            {
                name: "Level 2 - React.js Development",
                duration: "3 Months",
                fee: 15000,
                topics: [
                    "Modern JavaScript ES6+",
                    "Array Methods, Destructuring and Modules",
                    "React.js Fundamentals",
                    "Components, Props and State",
                    "Hooks: useState and useEffect",
                    "Forms and Event Handling",
                    "React Router and Navigation",
                    "API Integration using Fetch or Axios",
                    "2-Project: Website Using HTML, CSS, JavaScript",
                    "1-Project: Dynamic Website Using React",
                ],
            },
        ],
    },
    {
        id: 2,
        title: "Website Backend",
        icon: "⚙️",
        description: "Build server-side applications, APIs and databases.",
        levels: [
            {
                name: "Level 2 - Backend Fundamentals",
                duration: "2 Months",
                fee: 5000,
                topics: [
                    "Database Fundamentals",
                    "JSON Data Handling",
                    "Backend Development Fundamentals",
                    "Node.js",
                    "Node.js Modules and npm",
                    "HTTP and Client-Server Architecture",
                    "Basic Server Creation",
                    "Introduction to REST APIs",
                    "Mini Project: Basic Node.js Server",
                ],
            },
            {
                name: "Level 2 - Advanced Backend Development",
                duration: "3 Months",
                fee: 15000,
                topics: [
                    "MySQL or MongoDB",
                    "CRUD Operations",
                    "REST API Development",
                    "Routing and Middleware",
                    "Frontend and Database Integration",
                    "Authentication and Authorization",
                    "Password Hashing and Security Basics",
                    "Input Validation and Error Handling",
                    "Environment Variables",
                    "Backend Deployment",
                    "Project: Complete Backend API",
                ],
            },
        ],
    },
    {
        id: 3,
        title: "Web Hosting",
        subtitle: "Frontend + Backend",
        icon: "🚀",
        description:
            "Learn to develop complete websites from frontend to backend.",
        levels: [
            {
                name: "Level 1 - Fronted ",
                duration: "2 Day",
                fee: 2000,
                topics: [
                    "Frontend Hosting: Types of Hosting and Choosing the Right Plan",
                    "Purchasing a Domain Name and Web Hosting",
                    "Connecting Domain with Hosting and DNS Configuration",
                    "Hosting HTML, CSS, JavaScript and React.js Websites",
                    "SSL Certificate Setup and Making the Website Live",
                ],
            },
            {
                name: "Level 2 - Backend",
                duration: "3 Day",
                fee: 3000,
                topics: [
                    "Backend Hosting: Choosing Hosting for PHP and Node.js",
                    "Creating a Database and Configuring Database Credentials",
                    "Uploading Backend Files and Deploying Server-Side Code",
                    "Connecting Frontend with Backend APIs and Database",
                    "Testing Backend Functionality on a Live Website",
                ],
            },
        ],
    },
    {
        id: 4,
        title: "Artificial Intelligence (AI)",
        icon: "🤖",
        description:
            "Learn AI fundamentals, modern AI tools and AI applications.",
        levels: [
            {
                name: "Level 1 - AI Fundamentals",
                duration: "3 Months",
                fee: 25000,
                topics: [
                    "Introduction to Artificial Intelligence",
                    "AI, Machine Learning and Deep Learning Overview",
                    "Python Installation and Setup",
                    "Python Variables and Data Types",
                    "Conditions, Loops and Functions",
                    "Lists, Dictionaries and Sets",
                    "Python Modules and Libraries",
                    "Introduction to Data Handling",
                    "AI Tools and Responsible AI Usage",
                    "Mini Project: Python-Based AI Utility",
                ],
            },
            {
                name: "Level 2 - Generative AI and Applications",
                duration: "3 Months",
                fee: 30000,
                topics: [
                    "Machine Learning Fundamentals",
                    "Generative AI Concepts",
                    "Large Language Models (LLMs)",
                    "Prompt Engineering",
                    "Working with AI APIs",
                    "Python Integration with AI Services",
                    "Chatbot Development",
                    "Text Processing and AI Automation",
                    "AI Application Testing and Evaluation",
                    "AI Safety and Data Privacy",
                    "Project: AI Chatbot or Assistant",
                ],
            },
        ],
    },
    {
        id: 5,
        title: "Salesforce Admin",
        icon: "☁️",
        description: "Learn Salesforce CRM configuration and administration.",
        levels: [
            {
                name: "Level 1 - Salesforce Admin Fundamentals",
                duration: "1 Month",
                fee: 5000,
                topics: [
                    "Salesforce Introduction and CRM Concepts",
                    "Salesforce Setup and Navigation",
                    "Standard and Custom Objects",
                    "Fields, Tabs and Relationships",
                    "Page Layouts and Record Types",
                    "List Views and Search",
                    "Accounts, Contacts and Opportunities,Lead,Case etc",
                    "Reports and Dashboards",
                    "Data Import and Export Basics",
                    "Mini Project: CRM Configuration",
                ],
            },
            {
                name: "Level 2 - Advanced Salesforce Administration",
                duration: "1 Month",
                fee: 10000,
                topics: [
                    "Flow Builder and Automation",
                    "Profiles and Permission Sets",
                    "Approval Process Concepts",
                    "Validation Rules",
                    "Formula Fields",
                    "Roles and Role Hierarchy",
                    "Organization-Wide Defaults",
                    "Sharing Rules and Record Access",
                    "Data Loader",
                    "Debugging Flows and Troubleshooting",
                    "Real-World Admin Project",
                ],
            },
        ],
    },
    {
        id: 6,
        title: "Salesforce Developer",
        icon: "👨‍💻",
        description: "Learn Apex programming and custom Salesforce development.",
        levels: [
            {
                name: "Level 1 - Salesforce Development Fundamentals",
                duration: "1.5 Months",
                fee: 10000,
                topics: [
                    "Salesforce Developer Environment",
                    "Developer Console and VS Code Overview",
                    "Apex Introduction",
                    "Variables, Data Types and Operators",
                    "Conditions and Loops",
                    "Collections: List, Set and Map",
                    "Methods and Classes",
                    "SOQL Queries",
                    "SOSL Search",
                    "DML Operations",
                    "Exception Handling",
                    "Mini Project: Apex Data Operations",
                ],
            },
            {
                name: "Level 2 - Advanced Salesforce Development",
                duration: "1.5 Months",
                fee: 15000,
                topics: [
                    "Apex Triggers",
                    "Trigger Context Variables",
                    "Bulkification and Governor Limits",
                    "Trigger Handler Patterns",
                    "Asynchronous Apex",
                    "Batch Apex and Scheduled Apex",
                    "Queueable and Future Methods",
                    "Apex Test Classes and Code Coverage",
                    "REST API Integration Fundamentals",
                    "Debugging and Best Practices",
                    "Project: Automated Salesforce Application",
                ],
            },
        ],
    },
    {
        id: 7,
        title: "Salesforce LWC",
        icon: "⚡",
        description:
            "Build reusable user interfaces with Lightning Web Components.",
        levels: [
            {
                name: "Level 1 - LWC Fundamentals",
                duration: "1.5 Month",
                fee: 8000,
                topics: [
                    "Lightning Web Components Introduction",
                    "HTML and CSS Fundamentals",
                    "JavaScript Fundamentals",
                    "LWC Project Structure",
                    "Properties and Data Binding",
                    "Conditional Rendering",
                    "List Rendering",
                    "Event Handling",
                    "Parent-Child Component Basics",
                    "Mini Project: Custom Salesforce UI",
                ],
            },
            {
                name: "Level 2 - Advanced LWC Development",
                duration: "1.5 Month",
                fee: 12000,
                topics: [
                    "Lifecycle Hooks",
                    "Component Communication",
                    "Custom Events",
                    "Lightning Data Service",
                    "Creating and Deploying Components",
                    "Wire Service and Reactive Properties",
                    "Calling Apex from LWC",
                    "Navigation and Toast Messages",
                    "Forms and Record Operations",
                    "Error Handling and Loading States",
                    "Reusable Component Design",
                    "Project: Complete LWC Application",
                ],
            },
        ],
    },
    {
        id: 8,
        title: "Salesforce Admin + Developer + LWC",
        icon: "⚡",
        description:
            "Build reusable user interfaces with Lightning Web Components.",
        levels: [
            {
                name: "Level 1 - LWC Fundamentals",
                duration: "2 Month",
                fee: 20000,
                topics: [
                  "According to mention above Salesforce Admin Lavel 1 + Salesforce Developer Lavel 1 + Salesforce LWC Lavel 1 "
                ],
            },
            {
                name: "Level 2 - Advanced LWC Development",
                duration: "3 Month",
                fee: 30000,
                topics: [
                    "According to mention above Salesforce Admin Lavel 1 + Salesforce Developer Lavel 1 + Salesforce LWC Lavel 1 "
                ],
            },
        ],
    },
    {
        id: 9,
        title: "Digital Marketing",
        icon: "📈",
        description:
            "Learn digital marketing, advertising and lead generation.",
        levels: [
            {
                name: "Level 1 - Digital Marketing Fundamentals",
                duration: "1 Month",
                fee: 1500,
                topics: [
                    "Digital Marketing Introduction",
                    "Digital Marketing Channels",
                    "Website and Landing Page Fundamentals",
                    "SEO Fundamentals",
                    "Keyword Research",
                    "On-Page SEO",
                    "Content Marketing",
                    "Social Media Marketing",
                    "Content Creation Basics",
                    "Google Business Profile Fundamentals",
                    "Mini Project: Digital Marketing Plan",
                ],
            },
            {
                name: "Level 2 - Advanced Digital Marketing",
                duration: "1 Month",
                fee: 2500,
                topics: [
                    "Technical SEO Fundamentals",
                    "Off-Page SEO and Link Building",
                    "Google Ads Campaign Setup",
                    "Meta Ads Campaign Setup",
                    "Audience Targeting",
                    "Campaign Budgeting",
                    "Google Analytics Fundamentals",
                    "Conversion Tracking",
                    "Lead Generation Strategies",
                    "Campaign Optimization",
                    "Performance Reporting",
                    "Project: Marketing Campaign",
                ],
            },
        ],
    },
];

const formatPrice = (price) =>
    new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0,
    }).format(price);

function CoursesList() {
    const [selectedCourse, setSelectedCourse] = useState(null);

    const handleEnroll = (course, level) => {
        const phoneNumber = "919426944526";

        const message = `Hello A.P Tech Solutions,

I am interested in your course.

Course Name: ${course.title}
Level: ${level.name}
Duration: ${level.duration}
Course Fee: ${formatPrice(level.fee)}

Please share more details about the course and admission process.

Thank you.`;

        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
            message
        )}`;

        window.open(whatsappUrl, "_blank", "noopener,noreferrer");
    };

    return (
        <main className="ap-courses">
            <section className="ap-courses-hero">
                <span className="ap-courses-eyebrow">
                    A.P TECH SOLUTION
                </span>

                <h1>Our Professional Courses</h1>

                <p>
                    Learn practical skills, build real-world projects, and
                    prepare for your technology career.
                </p>
            </section>

            <section className="ap-courses-content">
                <div className="ap-courses-heading">
                    <div>
                        <h2>Explore Our Courses</h2>
                        <p>
                            Start from Level 1 or choose Level 2 if you already
                            know the fundamentals.
                        </p>
                    </div>

                    <span className="ap-course-count">
                        {courses.length} Courses
                    </span>
                </div>

                {/* Desktop Course Table */}
                <div className="ap-course-table-wrap">
                    <table className="ap-course-table">
                        <thead>
                            <tr>
                                <th>Course Name</th>
                                <th>Topics Covered</th>
                                <th>Duration</th>
                                <th>Level 1 Fee</th>
                                <th>Level 2 Fee</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {courses.map((course) => (
                                <tr key={course.id}>
                                    <td>
                                        <div className="ap-course-name">
                                            <span className="ap-course-icon">
                                                {course.icon}
                                            </span>

                                            <div>
                                                <strong>{course.title}</strong>

                                                {course.subtitle && (
                                                    <small>
                                                        {course.subtitle}
                                                    </small>
                                                )}
                                            </div>
                                        </div>
                                    </td>

                                    <td>
                                        <div className="ap-course-short-topics">
                                            <span>
                                                <b>Level 1:</b>{" "}
                                                {course.levels[0].topics
                                                    .slice(0, 3)
                                                    .join(", ")}
                                            </span>

                                            <span>
                                                <b>Level 2:</b>{" "}
                                                {course.levels[1].topics
                                                    .slice(0, 3)
                                                    .join(", ")}
                                            </span>
                                        </div>
                                    </td>

                                    <td>
                                        <div className="ap-course-duration">
                                            <span>
                                                {course.levels[0].duration}
                                            </span>
                                            <span>
                                                {course.levels[1].duration}
                                            </span>
                                        </div>
                                    </td>

                                    <td>
                                        <strong className="ap-course-price">
                                            {formatPrice(
                                                course.levels[0].fee
                                            )}
                                        </strong>
                                    </td>

                                    <td>
                                        <strong className="ap-course-price">
                                            {formatPrice(
                                                course.levels[1].fee
                                            )}
                                        </strong>
                                    </td>

                                    <td>
                                        <button
                                            type="button"
                                            className="ap-course-details-btn"
                                            onClick={() =>
                                                setSelectedCourse(course)
                                            }
                                        >
                                            Details
                                            <span aria-hidden="true">
                                                {" "}→
                                            </span>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Mobile Course Cards */}
                <div className="ap-course-mobile-list">
                    {courses.map((course) => (
                        <article
                            className="ap-course-card"
                            key={course.id}
                        >
                            <div className="ap-course-card-heading">
                                <span className="ap-course-icon">
                                    {course.icon}
                                </span>

                                <div>
                                    <h3>{course.title}</h3>
                                    <p>{course.description}</p>
                                </div>
                            </div>

                            <div className="ap-course-card-levels">
                                {course.levels.map((level, index) => (
                                    <div
                                        className="ap-course-level"
                                        key={level.name}
                                    >
                                        <div className="ap-course-level-title">
                                            <strong>{level.name}</strong>
                                            <strong>
                                                {formatPrice(level.fee)}
                                            </strong>
                                        </div>

                                        <p>{level.duration}</p>

                                        <p>
                                            {level.topics
                                                .slice(0, 4)
                                                .join(", ")}
                                        </p>

                                        <button
                                            type="button"
                                            className="ap-course-enroll-btn"
                                            onClick={() =>
                                                handleEnroll(course, level)
                                            }
                                        >
                                            Enquire for{" "}
                                            {index === 0 ? "Level 1" : "Level 2"}
                                            <span aria-hidden="true">
                                                {" "}→
                                            </span>
                                        </button>
                                    </div>
                                ))}
                            </div>

                            <button
                                type="button"
                                className="ap-course-details-btn ap-course-details-full"
                                onClick={() => setSelectedCourse(course)}
                            >
                                View Course Details →
                            </button>
                        </article>
                    ))}
                </div>

                <div className="ap-course-note">
                    <strong>Which level should you choose?</strong>
                    <p>
                        Level 1 is for beginners. Level 2 is for students who
                        already understand the basics and want to develop
                        advanced skills. Check the prerequisites in the
                        course details.
                    </p>
                </div>
            </section>

            {/* Course Details Modal */}
            {selectedCourse && (
                <div
                    className="ap-course-modal-overlay"
                    onMouseDown={(event) => {
                        if (event.target === event.currentTarget) {
                            setSelectedCourse(null);
                        }
                    }}
                >
                    <section
                        className="ap-course-modal"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="ap-course-modal-title"
                    >
                        <div className="ap-course-modal-header">
                            <div className="ap-course-modal-title-wrap">
                                <span className="ap-course-icon">
                                    {selectedCourse.icon}
                                </span>

                                <div>
                                    <span className="ap-courses-eyebrow">
                                        COURSE DETAILS
                                    </span>

                                    <h2 id="ap-course-modal-title">
                                        {selectedCourse.title}
                                    </h2>

                                    {selectedCourse.subtitle && (
                                        <p>{selectedCourse.subtitle}</p>
                                    )}
                                </div>
                            </div>

                            <button
                                type="button"
                                className="ap-course-close"
                                aria-label="Close course details"
                                onClick={() => setSelectedCourse(null)}
                            >
                                ×
                            </button>
                        </div>

                        <p className="ap-course-modal-description">
                            {selectedCourse.description}
                        </p>

                        <div className="ap-course-modal-levels">
                            {selectedCourse.levels.map((level, index) => (
                                <article
                                    className="ap-course-detail-level"
                                    key={level.name}
                                >
                                    <div className="ap-course-detail-top">
                                        <div>
                                            <span className="ap-course-level-badge">
                                                LEVEL {index + 1}
                                            </span>

                                            <h3>{level.name}</h3>
                                        </div>

                                        <div className="ap-course-detail-price">
                                            <strong>
                                                {formatPrice(level.fee)}
                                            </strong>
                                            <span>{level.duration}</span>
                                        </div>
                                    </div>

                                    <h4>What You Will Learn</h4>

                                    <ul className="ap-course-topic-list">
                                        {level.topics.map((topic) => (
                                            <li key={topic}>
                                                <span aria-hidden="true">
                                                    ✓
                                                </span>
                                                {topic}
                                            </li>
                                        ))}
                                    </ul>

                                    {/* WhatsApp enquiry for the selected level */}
                                    <button
                                        type="button"
                                        className="ap-course-enroll-btn"
                                        onClick={() =>
                                            handleEnroll(
                                                selectedCourse,
                                                level
                                            )
                                        }
                                    >
                                        Enquire for{" "}
                                        {index === 0 ? "Level 1" : "Level 2"}
                                        <span aria-hidden="true">
                                            {" "}→
                                        </span>
                                    </button>
                                </article>
                            ))}
                        </div>

                        <p className="ap-course-modal-footnote">
                            Course duration and fees are indicative and may be
                            confirmed with the admissions team before
                            enrollment.
                        </p>
                    </section>
                </div>
            )}
        </main>
    );
}

export default CoursesList;
